import { Component } from "react";
import { connect } from "react-redux";
import UserNaveBar from "./userNavBar";
import OrderForm from "../shared-components/orderForm";
import {
  setShowOrderModal,
  setShowServiceModal,
} from "../redux-state/features/orderState";
import UserApplicationsDetails from "./userApplicationsDetails";
import ServiceApplicationModal from "./service-application-modal";
import ServiceApplications from "./serviceApplications";
import Nav from "react-bootstrap/Nav";
import ViewOrderItemsModal from "./viewOrderModal";
import ChangePassWordModal from "../shared-components/changePassWordModal";
class User extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      tab_1: true,
      tab_2: false,
    };
  }
  handleClose = () => {
    this.props.setShowServiceModal(false);
  };
  handleTabs = ({ name }) => [
    this.setState({ tab_1: false, tab_2: false, [name]: true }),
  ];
  render() {
    const { show } = this.props;
    const { tab_1, tab_2 } = this.state;
    return (
      <div>
        <ChangePassWordModal />
        <ViewOrderItemsModal />
        <ServiceApplicationModal show={show} onClose={this.handleClose} />
        <OrderForm />
        <UserNaveBar />

        <Nav variant="tabs" className="mt-3">
          <Nav.Item>
            <Nav.Link
              href="#"
              active={tab_1}
              onClick={() => this.handleTabs({ name: "tab_1" })}
            >
              طلبات المقتنيات
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="link-1"
              active={tab_2}
              onClick={() => this.handleTabs({ name: "tab_2" })}
            >
              طلبات الخدمات
            </Nav.Link>
          </Nav.Item>
        </Nav>
        {tab_1 && <UserApplicationsDetails />}
        {tab_2 && <ServiceApplications />}
      </div>
    );
  }
}

const mapDispatchToProps = { setShowOrderModal, setShowServiceModal };
const mapStateToProps = (state) => ({
  uuid: state.userState.uuid,
  show: state.orderState.showServiceModal,
});
export default connect(mapStateToProps, mapDispatchToProps)(User);
